import React, { useEffect, useState } from 'react'
import { CiEdit } from 'react-icons/ci'
import { useNavigate, useParams } from 'react-router-dom'
import { ConvertJalaliDate } from 'utilities/helper/digitToMonth'
import useGetMoneyPoolManagement from 'pages/fund/fundPage/hooks/useGetMoneyPoolManagement'

interface IItemProps {
    index: number
    jalaliDate: string
    amount: number
    isDelayed: boolean
    setIsOpen: React.Dispatch<React.SetStateAction<boolean>>
    setLoanAmount: React.Dispatch<React.SetStateAction<number | undefined>>
    isPayed: boolean
    setSelectedInstallment: React.Dispatch<
        React.SetStateAction<number | undefined>
    >
    id: number
    shouldShowPayButton: boolean
}

export default function Item({
    index,
    jalaliDate,
    amount,
    isDelayed,
    setIsOpen,
    setLoanAmount,
    isPayed,
    setSelectedInstallment,
    id,
    shouldShowPayButton,
}: IItemProps) {
    const { moneyPool } = useParams()
    const navigate = useNavigate()
    const { moneyPoolManagement } = useGetMoneyPoolManagement(moneyPool)
    const [isLoading, setIsLoading] = useState(true)

    useEffect(() => {
        if (jalaliDate && amount) {
            setIsLoading(false)
        }
    }, [jalaliDate, amount])

    const handleEdit = () => {
        navigate(`edit/${id}`, {
            state: {
                amount: amount,
                number: index + 1,
            },
        })
    }

    const handlePayment = () => {
        setIsOpen(true)
        setSelectedInstallment(id)
        setLoanAmount(amount)
    }

    return (
        <div className="grid grid-cols-4 gap-1 p-1 bg-white w-full rounded-md my-2 items-center text-xs">
            <div className="min-h-[50px]">
                {isLoading ? (
                    <div className="bg-gray-1 rounded-md h-6 w-24 animate-pulse" />
                ) : (
                    <>
                        <p className="mb-3">قسط {index + 1}</p>
                        <p>{ConvertJalaliDate(jalaliDate)}</p>
                    </>
                )}
            </div>

            <div className="col-span-2 text-center">
                {isLoading ? (
                    <div className="bg-gray-1 rounded-md h-6 w-full animate-pulse" />
                ) : (
                    <>
                        {isDelayed && !isPayed && (
                            <div className="bg-red-1 text-white rounded-b-md text-center w-10 py-0.5 mx-auto -mt-5 min-h-[20px]">
                                معوق
                            </div>
                        )}
                        <p>مبلغ قسط: {amount?.toLocaleString()} تومان</p>
                    </>
                )}
            </div>

            <div className="text-center">
                {isPayed ? (
                    <div className="bg-gray-5 py-1 px-2 rounded-md text-xs">
                        پرداخت شده
                    </div>
                ) : (
                    <div className="flex justify-center items-center my-2">
                        {(moneyPoolManagement?.poolship?.role === 'mgr' ||
                            moneyPoolManagement?.poolship?.role === 'own') && (
                            <CiEdit
                                className="text-xl cursor-pointer hover:text-blue-500"
                                onClick={handleEdit}
                            />
                        )}
                    </div>
                )}

                {shouldShowPayButton && (
                    <button
                        className="bg-green-1 text-white py-1 px-2 rounded-md w-full hover:bg-green-600 transition-colors"
                        onClick={handlePayment}
                    >
                        پرداخت
                    </button>
                )}
            </div>
        </div>
    )
}
